<aside class="div-pagination ">
    <nav aria-label="Navegação de página exemplo "  >
        <ul class="pagination " >
            <li class="page-item page-item-hover "><a class="page-link ">1</a></li>
        </ul>
    </nav>
</aside>